import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { PulseLogo } from '../PulseLogo';
import { QrCodeSvg } from '../QrCodeSvg';
import styles from './PhoneScannerModal.module.scss';

export interface PhoneScannerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PhoneScannerModal: FC<PhoneScannerModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSimulateScan = () => {
    onClose();
    navigate('/mobile-asset');
  };

  return (
    <div className={styles.overlay} onClick={onClose} role="dialog" aria-modal="true">
      <div className={styles.phoneContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.phoneScreen}>
          <div className={styles.statusBar}>
            <span>9:41</span>
            <div className={styles.statusIcons}>
              <span>5G</span>
              <span>100%</span>
            </div>
          </div>

          <div className={styles.scannerHeader}>
            <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close scanner">
              ✕
            </button>
          </div>

          <div className={styles.viewfinderArea}>
            <div
              className={styles.labelSticker}
              onClick={handleSimulateScan}
              role="button"
              tabIndex={0}
              title="Click to simulate successful scan"
            >
              <div className={styles.stickerTop}>
                <span className={styles.stickerBrand}>Pulse Asset</span>
                <span className={styles.stickerId}>AHU-003</span>
              </div>
              <div className={styles.stickerQr}>
                <QrCodeSvg />
              </div>
              <div className={styles.stickerFooter}>
                <PulseLogo variant="stamp" theme="light" />
              </div>
            </div>
            <div className={styles.bracketTL} />
            <div className={styles.bracketTR} />
            <div className={styles.bracketBL} />
            <div className={styles.bracketBR} />
          </div>

          <div className={styles.scannerFooter}>
            <div className={styles.drawerHandle} />
            <div className={styles.scannerTitle}>Scan QR code</div>
            <p className={styles.scannerText}>
              Point your camera at a Pulse QR code on your phone to open the asset in Pulse.
            </p>
            <div className={styles.torchButton} onClick={handleSimulateScan} title="Toggle flash">
              🔦
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
